module.exports = __webpack_public_path__ + "static/media/baloon.bc39eac2.svg";